import { Visibility, VisibilityOff } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Grid,
  IconButton,
  InputAdornment,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { FormProvider } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import gsisLogo from "src/assets/images/gsis_logo.png";
import TextInput from "src/qubCommon/Inputs/TextInput";

const LoginBox = (props) => {
  const { loginForm, handleLogin } = props;

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async () => {
    setLoading(true);
    await handleLogin();
    setLoading(false);
  };

  return (
    <div
      style={{
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <div
        style={{
          background: "#003375",
          padding: 22,
          borderRadius: 20,
        }}
      >
        <FormProvider {...loginForm}>
          <Grid item xs={12} mb={2}>
            <h3
              align="center"
              style={{
                color: "#f1f1f1",
                fontWeight: 200,
                marginBottom: 12,
              }}
            >
              Σύνδεση Υπάλληλου/Φορέα
            </h3>
            <hr style={{ color: "#f1f1f1" }} />
          </Grid>

          <Grid item xs={12} mb={2}>
            <img src={gsisLogo} alt="gsis-logo" />
          </Grid>
          <Grid item xs={12}>
            <LoadingButton
              color="secondary"
              variant="contained"
              loading={loading}
              sx={{
                width: "100%",
                color: "#fefefe",
                fontWeight: 600,
                textTransform: "none",
              }}
              onClick={() =>
                window.location.replace(
                  `${import.meta.env.VITE_REACT_APP_BASE_URL}/auth/GoGsis_PA`
                )
              }
            >
              Συνέχεια με κωδικούς Δημόσιας Διοίκησης
            </LoadingButton>
          </Grid>
          <Grid item xs={12} mb={2} mt={2}>
            <Typography align="center" variant="h3" sx={{ color: "#fefefe" }}>
              ή
            </Typography>
          </Grid>
          <Grid item xs={12} justifyContent="center">
            <form>
              <Stack
                direction="column"
                spacing={1}
                sx={{ marginTop: 2, marginBottom: 2 }}
              >
                <Typography sx={{ color: "#fefefe" }} align="left">
                  Email
                </Typography>
                <TextInput
                  id="email"
                  name="email"
                  placeholder="Email"
                  size="medium"
                  autoComplete="email"
                />
              </Stack>
              <Stack direction="column" spacing={1}>
                <Typography align="left" sx={{ color: "#fefefe" }}>
                  Κωδικός Πρόσβασης
                </Typography>
                <TextInput
                  id="password"
                  name="password"
                  placeholder="Password"
                  autoComplete="current-password"
                  size="medium"
                  type={showPassword ? "text" : "password"}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleSubmit();
                  }}
                  InputProps={{
                    disableUnderline: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword((show) => !show)}
                          onMouseDown={(e) => e.preventDefault()}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Stack>
            </form>
          </Grid>
          <Grid item xs={12}>
            <LoadingButton
              color="secondary"
              variant="contained"
              loading={loading}
              sx={{ width: "100%", marginTop: 6 }}
              onClick={handleSubmit}
              style={{
                color: "#f1f1f1",
                fontWeight: 600,
                marginBottom: 12,
              }}
            >
              Συνδεση
            </LoadingButton>
          </Grid>
          <Grid
            item
            xs={12}
            onClick={() => {
              const baseUrl = import.meta.env.VITE_REACT_APP_BASE_URL;
              const fullUrl = `${baseUrl}/auth/GoGsisForgotPassword`;
              window.location.href = fullUrl;
            }}
            sx={{
              color: "#fefefe",
              textAlign: "center",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 500,
              mt: 1.5,
              transition: "0.25s ease",
              textDecoration: "underline",

              "&:hover": {
                color: "#90caf9",
                transform: "translateY(-1px)",
              },

              "&:active": {
                transform: "scale(0.97)",
              },
            }}
          >
            Επαναφορά Κωδικού Πρόσβασης
          </Grid>

          {/* <Typography
            variant="subtitle1"
            align="left"
            color="secondary"
            // onClick={() => navigate("/register")}
            onClick={() =>
              window.location.replace("https://www.anynet.gr/MHD/Registration")
            }
            sx={{
              marginTop: 4,
              cursor: "pointer",
              color: "#fefefe",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            Εγγραφή Νέου Χρήστη για την Υποβολή Αίτησης Προγράμματος ΜΗΔ
          </Typography> */}
        </FormProvider>
      </div>
    </div>
  );
};

export default LoginBox;
